var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('pie-chart',{attrs:{"title":"Répartition CA","subTitle":"par partenaire","series":_vm.series,"labels":_vm.labels,"loading":_vm.loading,"formatter":_vm.formatter,"colors":_vm.colors,"dags":[
    'partner_get_and_store_daily_dag',
    'partner_get_and_store_daily_ifempty_dag' ]}})}
var staticRenderFns = []

export { render, staticRenderFns }